module.exports = __webpack_public_path__ + "img/about.c1a28c5b.png";